import React from 'react';
import { StyledHeroTextOnly } from './StyledHeroTextOnly';

const HeroTextOnly = ({ textBelow, title, subtitle, paragraph, align, isLanding, greyParagraph, extraParagraph, bottomParagraph }) => {

  return (
    <React.Fragment>
      {
       
        <StyledHeroTextOnly align={align} greyParagraph={greyParagraph}>
          <div className="hero-text--wrap">
            <h4 className="padding--bottom md--title">{title}</h4>
            {
              paragraph &&
              <p className="preset-9">{paragraph}</p>
            }
          </div>
          {
            textBelow &&
            <div className="hero-text--wrap hero-text--below">
              {
                subtitle &&<h5 className="big--title">{subtitle}</h5>
              }
              {
                extraParagraph && <h6 className="md--title">{extraParagraph}</h6>
              }
              <p className="preset-9" dangerouslySetInnerHTML={{ __html: bottomParagraph }}></p>
            </div>
          }
          
          
        </StyledHeroTextOnly>
          
          
      }
    </React.Fragment>
  );
};

export default HeroTextOnly;
